import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import index from '@/components/index' // 首页
import login from '@/components/login' // 登录注册
import order from '@/components/order' // 下单
import MissionHall from '@/components/MissionHall' // 任务大厅
import productList from '@/components/productList' // 产品列表
import Trip from '@/components/Trip' // 我的行程
import more from '@/components/more' // 更多
import center from '@/components/center' // 摄影中心
import city from '@/components/city' // 约拍城市
import income from '@/components/income' // 店铺收益
import orderDetail from '@/components/orderDetail' // 订单详情
import applicantCity from '@/components/applicantCity' // 申请城市
import photographer from '@/components/photographer' // 摄影师管理
import shopCustomers from '@/components/shopCustomers' // 店铺客户
import Course from '@/components/common/Course' // 开店教程

// 店铺版
import Store_MissionHall from '@/views/store/MissionHall' // 任务中心
import Store_OrderDetail from '@/views/store/orderDetail' // 订单详情
import Store_Grapher from '@/views/store/grapher' // 店铺摄影师列表
import Store_Product from '@/views/store/productList' // 产品列表
import Store_PriceConfigs from '@/views/store/priceConfigs' // 套餐列表
import Store_Order from '@/views/store/order' // 店铺订单
import Store_More from '@/views/store/other' // 更多
import Store_ShopCustomers from '@/views/store/shopCustomers' // 店铺客户
import Store_StoreInfo from '@/views/store/storeInfo' // 店铺信息
import Store_Income from '@/views/store/income' // 店铺收益
import Store_UserChat from '@/views/store/userChat' // 用户沟通
import Store_HkHelp from '@/views/store/hkHelp' // 帮助中心


// 摄影师版
import Grapher_MissionHall from '@/views/grapher/MissionHall' // 任务大厅
import Grapher_OrderDetail from '@/views/grapher/orderDetail' // 订单详情
import Grapher_ShootCitys from '@/views/grapher/shootCitys' // 约拍城市
import Grapher_ApplicantCity from '@/views/grapher/applicantCity' // 申请约拍城市
import Grapher_Order from '@/views/grapher/order' // 我的订单
import Grapher_Center from '@/views/grapher/center' // 摄影师中心
import Grapher_Income from '@/views/grapher/income' // 我的收益
import Grapher_SignatureList from '@/views/grapher/signatureList' // 客户签字
import Grapher_SignatureDetail from '@/views/grapher/signatureDetail' // 客户签字详情
import Grapher_Signature from '@/views/grapher/signature' // 客户签字手写页


//公共部分
import User_Login from '@/views/user/login' // 登录
import User_UserInfo from '@/views/user/userInfo' // 用户信息
import User_ModifyPwd from '@/views/user/modifyPwd' // 修改密码
import User_Index from '@/views/user/index' // 默认页
import User_helpFeedback from '@/views/user/helpFeedback' // 帮助与反馈
import bindWechat from '@/views/user/bindWechat' // 绑定微信号



Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'User_Index',
    component: User_Index
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/order',
    name: 'order',
    component: order
  },
  {
    path: '/MissionHall',
    name: 'MissionHall',
    component: MissionHall
  },
  {
    path: '/productList',
    name: 'productList',
    component: productList
  },
  {
    path: '/Trip',
    name: 'Trip',
    component: Trip
  },
  {
    path: '/more',
    name: 'more',
    component: more
  },
  {
    path: '/center',
    name: 'center',
    component: center
  },
  {
    path: '/city',
    name: 'city',
    component: city
  },
  {
    path: '/income',
    name: 'income',
    component: income
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: orderDetail
  },
  {
    path: '/applicantCity',
    name: 'applicantCity',
    component: applicantCity
  },
  {
    path: '/photographer',
    name: 'photographer',
    component: photographer
  },
  {
    path: '/shopCustomers',
    name: 'shopCustomers',
    component: shopCustomers
  },
  {
    path: '/shopCustomers',
    name: 'shopCustomers',
    component: shopCustomers
  },
  {
    path: '/Course',
    name: 'Course',
    component: Course
  },
  /************************ 店铺版菜单 ************************/
  {
    path: '/Store/MissionHall',
    name: 'Store_MissionHall',
    component: Store_MissionHall
  },
  {
    path: '/Store/OrderDetail',
    name: 'Store_OrderDetail',
    component: Store_OrderDetail
  },
  {
    path: '/Store/Grapher',
    name: 'Store_Grapher',
    component: Store_Grapher
  },
  {
    path: '/Store/Product',
    name: 'Store_Product',
    component: Store_Product
  },
  {
    path: '/Store/PriceConfigs',
    name: 'Store_PriceConfigs',
    component: Store_PriceConfigs
  },
  {
    path: '/Store/Order',
    name: 'Store_Order',
    component: Store_Order
  },
  {
    path: '/Store/Other',
    name: 'Store_More',
    component: Store_More
  },
  {
    path: '/Store/ShopCustomers',
    name: 'Store_ShopCustomers',
    component: Store_ShopCustomers
  },
  {
    path: '/Store/StoreInfo',
    name: 'Store_StoreInfo',
    component: Store_StoreInfo
  },
  {
    path: '/Store/Income',
    name: 'Store_Income',
    component: Store_Income
  },
  {
    path: '/Store/UserChat',
    name: 'Store_UserChat',
    component: Store_UserChat
  },
  {
    path: '/Store/HkHelp',
    name: 'Store_HkHelp',
    component: Store_HkHelp
  },
  {
    path: '/User/helpFeedback',
    name: 'User_helpFeedback',
    component: User_helpFeedback
  },
  {
    path: '/User/bindWechat',
    name: 'bindWechat',
    component: bindWechat
  },


  /************************ 摄影师版菜单 ************************/
  {
    path: '/Grapher/MissionHall',
    name: 'Grapher_MissionHall',
    component: Grapher_MissionHall
  },
  {
    path: '/Grapher/OrderDetail',
    name: 'Grapher_OrderDetail',
    component: Grapher_OrderDetail
  },
  {
    path: '/Grapher/ShootCitys',
    name: 'Grapher_ShootCitys',
    component: Grapher_ShootCitys
  },
  {
    path: '/Grapher/ApplicantCity',
    name: 'Grapher_ApplicantCity',
    component: Grapher_ApplicantCity
  },
  {
    path: '/Grapher/Order',
    name: 'Grapher_Order',
    component: Grapher_Order
  },
  {
    path: '/Grapher/Center',
    name: 'Grapher_Center',
    component: Grapher_Center
  },
  {
    path: '/Grapher/Income',
    name: 'Grapher_Income',
    component: Grapher_Income
  },
  {
    path: '/Grapher/SignatureList',
    name: 'Grapher_SignatureList',
    component: Grapher_SignatureList
  },
  {
    path: '/Grapher/SignatureDetail',
    name: 'Grapher_SignatureDetail',
    component: Grapher_SignatureDetail
  },
  {
    path: '/Grapher/Signature',
    name: 'Grapher_Signature',
    component: Grapher_Signature
  },


  /************************ 公共部分 ************************/
  {
    path: '/User/Login',
    name: 'User_Login',
    component: User_Login
  },
  {
    path: '/User/UserInfo',
    name: 'User_UserInfo',
    component: User_UserInfo
  },
  {
    path: '/User/ModifyPwd',
    name: 'User_ModifyPwd',
    component: User_ModifyPwd
  },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js